export default __webpack_public_path__ + "static/media/DocumentDeleteIcon.a1e0cec0.svg";